import type {
  TableCommandFactory,
  TableRowRange,
} from 'components/Table/model/TableModel';

interface HandleRequestRowRangeCommand {
  rowRange: TableRowRange;
}

export const handleRequestRowRange: TableCommandFactory<
  HandleRequestRowRangeCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.visibleRowRange = command.rowRange;
  });
  cmdContext
    .getState()
    .onRequestRowRange?.(
      command.rowRange.startIndex,
      command.rowRange.endIndex,
    );
};
